// iPadOS Safari has sent a desktop "Macintosh" user agent by default since iPadOS 13, so
// server-side UA parsing (see apps/matrix/src/proxy.ts) always resolves these requests to
// desktop. A real Mac laptop never reports touch points, so this combination reliably means iPad.

const MAC_INTEL = 'MacIntel';

export function isIpadMasqueradingAsDesktop(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return (
    navigator.platform === MAC_INTEL && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window)
  );
}
